import { Geometry } from '@turf/turf';
import * as turf from '@turf/turf';

export class ActivityPoint {
    sequenceNumber: number;
    arrivalTime: string;
    departureTime: string;
    isTimingPoint: boolean;
    stopId: string;
    stopDescription: string;
    platformCode: string;

    geoJson: string;
    geo: Geometry;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (this.geoJson) {
            try {
                this.geo = JSON.parse(this.geoJson);
            } catch (error) {
                console.log(`could not parse geoJson JSON for activityPoint, stopDescription: ${this.stopDescription}`);
                this.geoJson = undefined;
            }
        }
    }

    public toFeature() {
        if (!this.geo) {
            return undefined;
        }

        const properties = {
            id: this.stopId,
            title: this.stopDescription + (this.platformCode ? ` ${this.platformCode}` : ''),
            isTimingPoint: this.isTimingPoint,
            zIndex: 10,
            type: 'stops'
        };

        const feature = turf.feature(this.geo, properties);
        return feature;
    }
}
